import {
    ConfigContent,
    ExternalDependenciesContent,
    InfoContent,
    devToolsPlugin,
    DevToolsLayout,
  } from '@backstage/plugin-devtools';
import { RequirePermission } from '@backstage/plugin-permission-react';
import {
    devToolsAdministerPermission,
    devToolsConfigReadPermission,
    devToolsExternalDependenciesReadPermission,
    devToolsInfoReadPermission,
  } from '@backstage/plugin-devtools-common';
import { UnprocessedEntitiesContent } from '@backstage/plugin-catalog-unprocessed-entities';

export { devToolsPlugin };


  export const DevToolsPage = () => {
    return (
      <RequirePermission permission={devToolsAdministerPermission}>
        <DevToolsLayout>
          <DevToolsLayout.Route path="info" title="Info">
            <RequirePermission permission={devToolsInfoReadPermission}>
              <InfoContent />
            </RequirePermission>
          </DevToolsLayout.Route>
          <DevToolsLayout.Route path="config" title="Config">
            <RequirePermission permission={devToolsConfigReadPermission}>
              <ConfigContent />
            </RequirePermission>
          </DevToolsLayout.Route>
          <DevToolsLayout.Route
            path="external-dependencies"
            title="External Dependencies"
          >
            <RequirePermission permission={devToolsExternalDependenciesReadPermission}>
              <ExternalDependenciesContent />
            </RequirePermission>
          </DevToolsLayout.Route>
          
          <DevToolsLayout.Route path="unprocessed-entities" title="Unprocessed Entities">
            <UnprocessedEntitiesContent />
          </DevToolsLayout.Route>
        </DevToolsLayout>
      </RequirePermission>
    );
  };
  
  export const customDevToolsPage = <DevToolsPage />;